import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { ArrowRight } from "lucide-react";

/** FAQ accordion (server-cleaned: only valid, deduped, included items arrive here;
 *  its FAQPage schema is generated server-side from the same cleaned list). */
export function FaqSection({ items }) {
  if (!items?.length) return null;
  return (
    <section className="my-10" data-testid="resource-faq">
      <h2 className="font-heading text-2xl font-semibold text-navy">Frequently Asked Questions</h2>
      <Accordion type="single" collapsible className="mt-4">
        {items.map((f, i) =>
          f.question && f.answer ? (
            <AccordionItem key={i} value={`faq-${i}`}>
              <AccordionTrigger className="text-left text-base font-medium text-slate-800" data-testid={`faq-q-${i}`}>
                {f.question}
              </AccordionTrigger>
              <AccordionContent>
                <div className="resource-article-body text-[0.95rem]" data-testid={`faq-a-${i}`}>
                  {String(f.answer).split(/\n{2,}/).map((para, j) => (
                    <p key={j}>{para.split("\n").map((line, k) => (
                      <span key={k}>{line}{k < para.split("\n").length - 1 ? <br /> : null}</span>
                    ))}</p>
                  ))}
                </div>
              </AccordionContent>
            </AccordionItem>
          ) : null
        )}
      </Accordion>
    </section>
  );
}

/** Related/next-best internal links (crawlable). */
export function RelatedPages({ pages }) {
  if (!pages?.length) return null;
  return (
    <section className="my-10" data-testid="resource-related">
      <h2 className="font-heading text-xl font-semibold text-navy">Keep reading</h2>
      <div className="mt-4 grid gap-4 sm:grid-cols-2">
        {pages.map((p) => (
          <Link
            key={p.id}
            to={p.url_path}
            className="group rounded-xl border border-slate-200 bg-white p-5 transition-colors hover:border-editorial"
          >
            {p.section ? (
              <span className="text-xs font-medium uppercase tracking-wide text-slate-400">{p.section}</span>
            ) : null}
            <h3 className="mt-1 font-medium text-navy group-hover:text-editorial">{p.title}</h3>
            {(p.summary_answer || p.meta_description) ? (
              <p className="mt-1 line-clamp-2 text-sm text-slate-500">
                {p.summary_answer || p.meta_description}
              </p>
            ) : null}
            <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-editorial">
              Read <ArrowRight className="h-3.5 w-3.5" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}
